import type { QuestionCore } from "../contracts";
import { defaultThemeV2 } from "../../theme/defaultThemeV2";

export type ImageRaw = {
  type: "image";
  content: string;
  image: string;
  alt_text?: string | null;
  number_seconds: number;
  auto_response?: string | null;
  error_message?: string;
};

export type ImageDefinition = {
  prompt: string;
  image: string;
  altText?: string;
  numberSeconds: number;
  autoResponse: boolean;
  error?: string;
};

export type ImageDraft = Record<string, never>;
export type ImageEvent = { type: "acknowledge" };
export type ImageResponse = { type: "image"; value: "ok" };

export const imageCore: QuestionCore<
  ImageRaw,
  ImageDefinition,
  ImageDraft,
  ImageEvent,
  ImageResponse
> = {
  decode: (raw) => {
    if (typeof raw.image !== "string" || !raw.image) {
      throw new Error("Image question requires an image URL.");
    }
    return {
      prompt: raw.content,
      image: raw.image,
      numberSeconds: raw.number_seconds,
      autoResponse: raw.auto_response === "ok",
      ...(raw.alt_text ? { altText: raw.alt_text } : {}),
      ...(raw.error_message ? { error: raw.error_message } : {}),
    };
  },
  initialize: () => ({}),
  update: (_definition, draft) => draft,
  validate: () => ({ valid: true }),
  encode: () => ({ type: "image", value: "ok" }),
  projectTranscript: (definition, _draft, copy = defaultThemeV2.copy) => ({
    kind: "image",
    question: definition.prompt,
    answer: definition.altText ?? copy.status.imageViewed,
  }),
};
